import React, {FunctionComponent} from 'react';
import { Icon } from '@/components';
import classnames from 'classnames';
import { BackTop as ABackTop } from 'antd';
import StylesType from '@/types/StylesType';
import './style';

interface BackTopProps extends StylesType{
    /** 名称 */
    readonly name?: string;
    /** icon类型 */
    readonly type?: string;
    /** 滚动高度达到此参数值才出现  */
    readonly visibilityHeight?: number;
    /** 设置需要监听其滚动事件的元素，值为一个返回对应 DOM 元素的函数 */
    target?: () => HTMLElement | Window;
}

export const BackTop: FunctionComponent<BackTopProps> = props => {
  
    const { prefixCls, name, type, visibilityHeight, target, className, style } = props;
  
  
  return (
        <ABackTop target={target} visibilityHeight={visibilityHeight} style={style} className={classnames(prefixCls,className)}>
            <Icon className={classnames(`${prefixCls}-icon`)} type={type} />
            <pre>{name}</pre>
        </ ABackTop>
    )
  
}

BackTop.defaultProps = {
    name: '返回\n顶部',
    type: 'iconup',
    prefixCls: 'gc-resident-backTop',
    visibilityHeight: 100
}

export default BackTop;
